// tslint:disable
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { Classes, MPDButton } from "src/mpd-library";

import Measure, { BoundingRect } from "react-measure";

import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertComposeActions, formatDateTime } from "src/actions";

import { FloatingInput } from 'src/components';

import { Alert, TabId, Text } from "@blueprintjs/core";

import { IRightSideProps, RightSide } from "./right-side";

import { AlertSummary, IAlertSummaryProps } from "./alert-summary";

import "./styles.css";

interface IPreviewSendProps extends IRightSideProps, IAlertSummaryProps {
  previewSend: any;
  launchActive: boolean;
  isMobileSize: boolean;
  deviceType: any;
  scrollTop: number;
  scrolling?: boolean;
  onInputChanged: (
    id: string,
    value: string
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onSendCompose: () => (dispatch: Dispatch<any>) => Promise<void>;
  onRetryCompose: () => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseCompose: () => (dispatch: Dispatch<any>) => Promise<void>;
}

interface IPreviewSendState {
  bounds?: BoundingRect;
  mapTopStyle?: number;
}

class PreviewSend extends React.Component<
  IPreviewSendProps,
  IPreviewSendState
> {
  private inputs: Array<React.RefObject<HTMLInputElement>>;

  public constructor(props: IPreviewSendProps) {
    super(props);
    this.onTabChanged.bind(this);
    this.onInputChanged = this.onInputChanged.bind(this);
    this.onSendCompose = this.onSendCompose.bind(this);
    this.onRetryCompose = this.onRetryCompose.bind(this);
    this.onCloseCompose = this.onCloseCompose.bind(this);
    this.adjustMapLocation = this.adjustMapLocation.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.inputs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef()
    ];

    this.state = {
      mapTopStyle: undefined,
      bounds: undefined,
    };
  }

  public componentWillReceiveProps(nextProps: IPreviewSendProps) {
    if(nextProps.scrollTop !== this.props.scrollTop) {
      this.adjustMapLocation(nextProps.scrollTop);
    }
  }

  public render() {
    const { launchActive, previewSend, isMobileSize, deviceType, scrolling } = this.props;
    const { mapTopStyle } = this.state;

    const classes = classNames(myClasses.ALERTS_CONTENT_COMPOSE_PREVIEW_SEND, scrolling && (deviceType === 'iOS' || deviceType === 'Android') && Classes.LOADING);

    return (
      <Measure
        bounds
        onResize={contentRect => {
          this.setState({ bounds: contentRect.bounds }, () => {
            this.adjustMapLocation(this.props.scrollTop);
          });
        }}
      >
        {({ measureRef }) => (
          <div
            className={classes}
            tabIndex={-1}
          >
            <div className="preview-send-inner-container" ref={measureRef}>
              <Alert
                className={classNames("preview-send-alert")}
                canEscapeKeyCancel={true}
                canOutsideClickCancel={true}
                isOpen={launchActive}
                cancelButtonText=''
                onCancel={this.onCloseCompose}
              >
                <div className="inner-container">
                  <MPDButton
                    onClick={this.onCloseCompose}
                    className="exit"
                    name="compose-alert-exit"
                  />
                  <Text className="header"> Enter Launch Code </Text>
                  <p> This is your 4 digit passcode that only you know </p>
                  <div className="launch-code-container">
                    <FloatingInput
                      type="text"
                      floatingType="compose"
                      autoCapitalize="none"
                      autoCorrect="none"
                      onKeyDown={this.onKeyDown}
                      inputRef={this.inputs[0]}
                      data-id="launch1"
                      maxLength={1}
                      value={previewSend.launch1}
                      onChange={this.onInputChanged}
                      placeholder=""
                      tabIndex={1}
                    />
                    <FloatingInput
                      type="text"
                      floatingType="compose"
                      autoCapitalize="none"
                      autoCorrect="none"
                      onKeyDown={this.onKeyDown}
                      data-id="launch2"
                      maxLength={1}
                      inputRef={this.inputs[1]}
                      value={previewSend.launch2}
                      onChange={this.onInputChanged}
                      placeholder=""
                      tabIndex={2}
                    />
                    <FloatingInput
                      type="text"
                      floatingType="compose"
                      autoCapitalize="none"
                      autoCorrect="none"
                      onKeyDown={this.onKeyDown}
                      maxLength={1}
                      data-id="launch3"
                      inputRef={this.inputs[2]}
                      value={previewSend.launch3}
                      onChange={this.onInputChanged}
                      placeholder=""
                      tabIndex={3}
                    />
                    <FloatingInput
                      type="text"
                      floatingType="compose"
                      autoCapitalize="none"
                      autoCorrect="none"
                      onKeyDown={this.onKeyDown}
                      data-id="launch4"
                      inputRef={this.inputs[3]}
                      maxLength={1}
                      value={previewSend.launch4}
                      onChange={this.onInputChanged}
                      placeholder=""
                      tabIndex={4}
                    />
                  </div>
                  <div className="footer">
                    <MPDButton
                      onClick={this.onRetryCompose}
                      text="Try another option"
                    />
                    <MPDButton
                      className={classNames(
                        previewSend.launch1.length > 0 &&
                          previewSend.launch2.length > 0 &&
                          previewSend.launch3.length > 0 &&
                          previewSend.launch4.length > 0 &&
                          Classes.ACTIVE
                      )}
                      onClick={this.onSendCompose}
                      text="Send"
                    />
                  </div>
                </div>
              </Alert>
              <AlertSummary previewSend={previewSend} tabIndex={-1} />
              <RightSide
                previewSend={previewSend}
                mapTopStyle={isMobileSize ? mapTopStyle : undefined}
                tabIndex={-1}
              />
            </div>
          </div>
        )}
      </Measure>
    );
  }

  private adjustMapLocation(scrollTop: number) {
    const { bounds } = this.state;
    const { isMobileSize } = this.props;
    if (bounds && isMobileSize) {
      const mapTopStyle = bounds.height - 146 - scrollTop;
      this.setState({ mapTopStyle });
    }
  }

  private onKeyDown(event: any) {
    const current = event.currentTarget;
    let nextRef;
    setTimeout(() => {
      const length = current.value.length;
      switch (current.dataset.id) {
        case "launch1":
          nextRef = this.inputs[1].current;
          if (length > 0 && nextRef) {
            nextRef.focus();
          }
          break;
        case "launch2":
          if (length > 0) {
            nextRef = this.inputs[2].current;
            if (nextRef) {
              nextRef.focus();
            }
          } else if (length === 0) {
            nextRef = this.inputs[0].current;
            if (nextRef) {
              nextRef.focus();
            }
          }
          break;
        case "launch3":
          if (length > 0) {
            nextRef = this.inputs[3].current;
            if (nextRef) {
              nextRef.focus();
            }
          } else if (length === 0) {
            nextRef = this.inputs[1].current;
            if (nextRef) {
              nextRef.focus();
            }
          }
          break;
        case "launch4":
          if (length === 0) {
            nextRef = this.inputs[2].current;
            if (nextRef) {
              nextRef.focus();
            }
          }
      }
    }, 10);
  }

  private onCloseCompose(event: any) {
    this.props.onCloseCompose();
  }

  private onInputChanged(event: any) {
    const id = event.currentTarget.dataset.id;
    const value = event.target.value;
    this.props.onInputChanged(id, value);
  }

  private onRetryCompose() {
    this.props.onRetryCompose();
  }

  private onSendCompose() {
    this.props.onSendCompose();
  }

  private onTabChanged(event: any, newTabId: TabId) {
    // console.log(newTabId, "tabId");
  }
}

const mapStateToProps = (state: any) => {
  const { alerts, global } = state;
  const { deviceType, isMobileSize } = global;
  const { composeData } = alerts;
  const launchActive = composeData.previewSend.launchActive;

  const launch1 = composeData.previewSend.launch1;
  const launch2 = composeData.previewSend.launch2;
  const launch3 = composeData.previewSend.launch3;
  const launch4 = composeData.previewSend.launch4;

  const {
    chooseAudience,
    selectChannels,
    alertDetails,
    composeMessage
  } = composeData;
  const geoFence = chooseAudience.geoFence;
  let audience;

  for (const key of Object.keys(chooseAudience.audiences)) {
    if (chooseAudience.audiences[key].status) {
      audience = key;
    }
  }

  const channels = [];

  for (const key of Object.keys(selectChannels)) {
    if (selectChannels[key].status) {
      channels.push(key);
    }
  }

  let expiration = alertDetails.expiration.value;

  if (expiration === "custom") {
    expiration = "";
    expiration = formatDateTime(
      alertDetails.expiration.custom.days,
      "days ",
      expiration
    );
    expiration = formatDateTime(
      alertDetails.expiration.custom.hours,
      "hours ",
      " " + expiration
    );
    expiration = formatDateTime(
      alertDetails.expiration.custom.minutes,
      "minutes",
      " " + expiration
    );
  }

  const incidentLocation = alertDetails.incidentLocation;
  const headline = composeMessage.messageDetails.headline.value;
  const description = composeMessage.messageDetails.description.value;
  const mediaFiles = composeMessage.multiMedia.files;
  let thumbnails = [];
  let files = [];

  for (let i = 0; i < mediaFiles.length; i++) {
    if (mediaFiles[i].id.includes("image")) {
      if (i < 6) {
        thumbnails.push(mediaFiles[i].src);
      }
    } else {
      files.push(mediaFiles[i]);
    }
  }

  const date = "December 31, 2018  04:32 AM";
  const severity = alertDetails.severity.type;
  const previewSend = {
    channels,
    date,
    headline,
    files,
    description,
    thumbnails,
    expiration,
    launch1,
    launch2,
    launch3,
    launch4,
    incidentLocation,
    audience,
    severity,
    geoFence
  };

  return {
    previewSend,
    isMobileSize,
    deviceType,
    launchActive
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onCloseCompose: bindActionCreators(
      alertComposeActions.onPreviewSendToggleLaunch,
      dispatch
    ),
    onSendCompose: bindActionCreators(
      alertComposeActions.onSendCompose,
      dispatch
    ),
    onRetryCompose: bindActionCreators(
      alertComposeActions.onRetryCompose,
      dispatch
    ),
    onInputChanged: bindActionCreators(
      alertComposeActions.onLaunchCodeChanged,
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewSend);



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/preview-send/preview-send.tsx